import Vue from 'vue';
import Vuex from 'vuex';
import {commonActions, commonMutations, commonState} from './common-vuex';

Vue.use(Vuex);

export default new Vuex.Store({
	strict: process.env.NODE_ENV !== 'production',
	modules: {
		common: {
			namespaced: true,
			actions: commonActions,
			mutations: commonMutations,
			state: commonState
		}
	}
});
